module.exports = __webpack_public_path__ + "static/media/gmadpay-logo.06718db5.svg";